import dayjs from 'dayjs';
import { IDevice } from 'app/shared/model/device.model';

export interface IRepairModeAuditHistory {
  id?: number;
  device?: IDevice | null;
  status?: 'ON' | 'OFF' | null;
  startTime?: dayjs.Dayjs | string | null;
  endTime?: dayjs.Dayjs | string | null;
  cancelledBy?: string | null;
  createdBy?: string | null;
  createdDate?: dayjs.Dayjs | string | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: dayjs.Dayjs | string | null;
}

export const defaultValue: Readonly<IRepairModeAuditHistory> = {};
